import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const GoogleWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 39 36"
      fill="none"
      ref={forwardedRef}
    >
      <g id="Brand-logos">
        <g id="Google_Analytics_(11) 1" clipPath="url(#clip0_5481_113160)">
          <path
            id="Vector"
            d="M28.8348 26.9243C28.8348 28.5456 27.5096 29.9127 25.8782 29.9127H25.5202C23.991 29.7104 22.8694 28.3427 22.9206 26.8232V9.19557C22.8694 7.67575 23.991 6.35826 25.5202 6.10566C27.1516 5.9043 28.6299 7.06808 28.8348 8.68874V26.9243Z"
            fill="white"
          />
          <path
            id="Vector_2"
            d="M10.125 24.0372C10.7097 24.0372 11.2813 24.2095 11.7675 24.5323C12.2538 24.8551 12.6327 25.3139 12.8565 25.8507C13.0803 26.3875 13.1388 26.9782 13.0247 27.5481C12.9107 28.118 12.6291 28.6415 12.2156 29.0523C11.8021 29.4632 11.2753 29.743 10.7018 29.8564C10.1282 29.9697 9.53376 29.9115 8.99351 29.6892C8.45327 29.4668 7.99151 29.0903 7.66664 28.6072C7.34176 28.124 7.16836 27.556 7.16836 26.975C7.11745 25.354 8.49361 24.0372 10.125 24.0372ZM17.9244 15.0713C16.2927 15.1728 15.02 16.5402 15.02 18.1612V26.1141C15.02 28.2412 15.9885 29.5584 17.3647 29.8622C18.9964 30.1664 20.5256 29.1531 20.8822 27.5321C20.9332 27.3297 20.9332 27.1271 20.9332 26.9244V18.06C20.9332 16.4387 19.6079 15.0713 17.9766 15.0713H17.9244Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5481_113160">
          <rect width="21.6667" height="23.8333" fill="white" transform="translate(7.16699 6.08301)" />
        </clipPath>
      </defs>
    </svg>
  )
})
